import initSliders from "./initSliders.js";

const {
    initModalProductSlider,
} = initSliders();
const initModals = () => {
    const body = document.body;
    const dialogs = document.querySelectorAll('dialog');
    const openModalBtns = document.querySelectorAll('[data-toggle-modal]');
    const openProductModalBtns = document.querySelectorAll('[data-toggle-product-modal]');
    const openJobModalBtns = document.querySelectorAll('[data-toggle-job-modal]');

    const closeAllModals = () => {
        dialogs.forEach(dialog => {
            if (dialog.open) dialog.close();
        });
        body.style.paddingRight = '0';
        body.classList.remove('overflow--hidden');
    };

    const handleOpenModal = (btn) => {
        closeAllModals();

        const targetSelector = btn.dataset.targetModal;
        const dialog = document.querySelector(targetSelector);

        console.log('Opening modal:', targetSelector, dialog);

        if (!dialog) {
            console.warn('Modal not found:', targetSelector);
            return;
        }

        if( targetSelector === '#film-info__dialog' ) {
            const imageWebp = btn.dataset?.imageWebp;
            const title = btn.dataset?.title;
            const description = btn.dataset?.description;

            // console.log('imageWebp', imageWebp);
            // console.log('description', description);

            const dialogFilmInfoElm = dialog.querySelector('.film__info');

            const picture = document.createElement('picture');
            picture.className = 'film__info_image';


            if (imageWebp) {
                const sourceWebp = document.createElement('source');
                sourceWebp.srcset = imageWebp;
                sourceWebp.type = 'image/webp';
                picture.appendChild(sourceWebp);
            }

            const img = document.createElement('img');
            img.src = imageWebp;
            img.alt = title;
            img.loading = 'lazy';
            picture.appendChild(img);

            dialogFilmInfoElm.innerHTML = '';
            dialogFilmInfoElm.appendChild(picture);

            const descElm = document.createElement('div');
            descElm.className = 'film__info_description';
            descElm.innerHTML = description || '';
            dialogFilmInfoElm.appendChild(descElm);

        }

        body.style.paddingRight = window.innerWidth - body.clientWidth + 'px';
        body.classList.add('overflow--hidden');
        dialog.showModal();

        if (btn.dataset.id) {
            const input = dialog.querySelector('[name="id"]');
            if (input) input.value = btn.dataset.id;
        }
    };

    // ------------------------
    // Открытие модалки с продуктом
    // ------------------------
    const handleOpenProductModal = (btn) => {
        closeAllModals();

        const targetSelector = btn.dataset.targetModal;
        const dialog = document.querySelector(targetSelector);

        if (!dialog) {
            console.warn('Product modal not found:', targetSelector);
            return;
        }

        body.style.paddingRight = window.innerWidth - body.clientWidth + 'px';
        body.classList.add('overflow--hidden');

        let id = btn.dataset.productId;
        console.log('Loading product data for modal...', id);

        clearProductModal();
        const productData = loadProduct(id).then(data => {
            console.log('Product data loaded:', data.product_id);
            renderProductInModal(data);
            initModalProductSlider();
        }).catch(err => {
            clearProductModal();
            console.error('Error loading product data:', err?.message);
        });
        dialog.showModal();
    };

    const handleOpenJobModal = (btn) => {
        closeAllModals();

        const targetSelector = btn.dataset.targetModal;
        const dialog = document.querySelector(targetSelector);

        if (!dialog) {
            console.warn('Job modal not found:', targetSelector);
            return;
        }

        body.style.paddingRight = window.innerWidth - body.clientWidth + 'px';
        body.classList.add('overflow--hidden');

        let id = btn.dataset.jobId;
        console.log('Loading job data for modal...', id);

        dialog.showModal();
    };

    async function loadProduct(id) {
        const res = await axios.get(`/api/product/${id}`, {
            headers: { Accept: 'application/json' }
        });

        return res.data;
    }

    const renderProductInModal = (data) => {
        const info_content = document.querySelector('#product-info__dialog #dialog__product_right');
        const info_image = document.querySelector('#product-info__dialog #dialog__product_left');
        info_content.innerHTML = data.info_content;
        info_image.innerHTML = data.info_image;
    };

    const clearProductModal = () => {
        const info_content = document.querySelector('#product-info__dialog #dialog__product_right');
        const info_image = document.querySelector('#product-info__dialog #dialog__product_left');
        info_content.innerHTML = '';
        info_image.innerHTML = '';
    };

    // ------------------------
    // Назначаем обработчики
    // ------------------------
    openModalBtns.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            handleOpenModal(btn);
        });
    });

    openProductModalBtns.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            handleOpenProductModal(btn);
        });
    });

    openJobModalBtns.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();
            handleOpenJobModal(btn);
        });
    });

    // ------------------------
    // Обработка закрытия модалок
    // ------------------------
    dialogs.forEach(dialog => {
        dialog.addEventListener('mousedown', e => {
            // безопасно получаем ближайшую кнопку (может быть null)
            const btn = e.target.closest && e.target.closest('button');

            // если клик по кнопке с data-close-dialog — закрываем
            if (btn && btn.hasAttribute('data-close-dialog')) {
                closeAllModals();
                return;
            }

            // если клик по самому диалогу (overlay) или по элементу с классом modal__dialog — закрываем
            // защищаем доступ к classList (например, если target — текстовый узел)
            const target = e.target;
            const isModalDialogElem = target && target.classList && target.classList.contains('modal__dialog');
            if (isModalDialogElem || target === dialog) {
                closeAllModals();
                return;
            }
        });

        document.addEventListener('keydown', e => {
            if (e.key === 'Escape') closeAllModals();
        });
    });
};

export default initModals;
